import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';

import "./RadioListModal.scss";

import UniversalButton from "components/uiComponents/UniversalButton";
import FolderTemplates from "../../FolderTemplates";

import { ReactComponent as PremiumTemplatesIcon } from "static/images/premium_templates.svg";
import { ReactComponent as PlusСircleIcon } from "static/icons/plus-circle.svg";
import OptionMenu from "../../template/OptionMenu";
import ModalComponent from "../ModalComponent";
import CreateFolder from "../../template/CreateFolder";
import ProofModal from "../ProofModal";
import {
  addFolderTemplate,
  deleteFolderTemplate,
  renameFolderTemplate
} from "../../../store/actions/template";
import { showToast } from "../../../utils/helpers";
import { addSelectItems } from "../../../store/actions/table";
import { clearColors } from "utils/builder/IScheduleLogic";
import { getCurrentNamespace } from "utils/crossTabSync";

const RadioListModal = ({
  options,
  selectedOption,
  title,
  closeModal,
  onChangeTemplate,
  handleOpenPremiumModal,
  subscreption
}) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { templatesFolder } = useSelector((state) => state.viewer);

  const [activeOption, setActiveOption] = useState(null);
  const [activeBanner, setActiveBanner] = useState(true);
  const [activeFolder, setActiveFolder] = useState(null);
  const [optionMenuFolder, setOptionMenuFolder] = useState(null);
  const [isCreateFolderModal, setCreateFolderModal] = useState(false);
  const [scroll, setScroll] = useState(false);
  const [isEditFolder, setEditFolder] = useState(false);
  const [infoAboutFolder, setInfoAboutFolder] = useState(false);
  const [proofModal, setProofModal] = useState(false);

  useEffect(() => {
    if (selectedOption && options) {
      const currentOption = options.find(item => item === selectedOption);

      if (currentOption) setActiveOption(currentOption);
    }

  }, []);


  const handleLoad = (e) => {
    e.preventDefault();

    onChangeTemplate?.(activeOption, activeFolder);

    const modelId = getCurrentNamespace();
    dispatch(addSelectItems({ selectItems: {}, id: 1, modelId }));

    closeModal?.();
  };

  const handleCancel = () => {
    closeModal?.();
  };

  const openOptionMenuFolder = (event, name) => {

    event.stopPropagation();

    if (optionMenuFolder && name === optionMenuFolder?.folderName) {
      closeOptionMenuFolder();
    } else {

      const clientX = event.clientX + 19;
      const clientY = event.clientY - 20;

      setOptionMenuFolder({ clientX, clientY, templateName: null, folderName: name });
      setScroll(false);
    }
  }

  const closeOptionMenuFolder = () => {
    setOptionMenuFolder(null);
  }

  const closeCreateFolderModal = () => {
    setCreateFolderModal(false);
  };

  const openCreateFolderModal = () => {
    setCreateFolderModal(true);
  };

  const closePopups = () => {
    setScroll(true);
    setOptionMenuFolder(null);
  };

  const closeEditFolder = () => {
    setEditFolder(false);
  };

  const openEditFolder = () => {
    setInfoAboutFolder(optionMenuFolder);
    closeOptionMenuFolder();
    setEditFolder(true);
  }

  const editFolder = async (originalNameFolder, newNameFolder) => {
    try {
      await dispatch(renameFolderTemplate(originalNameFolder, newNameFolder));
      showToast(true, t('folder_template_was_edited'));
    } catch (error) {
      showToast(false, error);
    }
  }

  const addFolder = async (folderName) => {
    try {
      await dispatch(addFolderTemplate(folderName));
      showToast(true, t('folder_template_was_created'));
    } catch (error) {
      showToast(false, error);
    }
  }

  const closeProofModal = () => {
    setProofModal(false);
  };

  const deleteItem = async () => {

    const folderName = infoAboutFolder.folderName;

    try {
      await dispatch(deleteFolderTemplate(folderName));
      showToast(true, t('folder_template_was_deleted'));
    } catch (error) {
      showToast(false, error);
    }

    closeProofModal();
  }

  const openProofModal = () => {
    setInfoAboutFolder(optionMenuFolder);
    closeOptionMenuFolder();
    setProofModal(true);
  }

  return (
    <div className="radio-list-modal">
      {!!title &&
        <h2>{title}</h2>
      }
      {
        activeBanner && !subscreption ?
          <div className="premium-banner">
            <PremiumTemplatesIcon />
            <p className="premium-banner__text">{t('apply_premium_account_text')}</p>
            <div className="premium-banner__close-button" onClick={() => setActiveBanner(false)}></div>
          </div> : null
      }

      <div className="radio-list-modal__options_container" onScroll={closePopups}>
        {templatesFolder && Object.keys(templatesFolder).map((folderName, index) => {
          const handleOptionClick = (option, folder) => {
            setActiveOption(option);
            setActiveFolder(folder);
          };

          const templates = templatesFolder[folderName];

          return (
            <FolderTemplates
              key={folderName}
              folderName={folderName}
              templates={templates}
              handleOptionClick={handleOptionClick}
              activeOption={activeOption}
              openOptionMenuFolder={openOptionMenuFolder}
              optionMenuFolder={optionMenuFolder}
              scroll={scroll}
              openProofModal={openProofModal}
              closeOptionMenuFolder={closeOptionMenuFolder}
              setScroll={setScroll}
            />
          );
        })
        }
      </div>

      <div className="radio-list-modal__btns">
        <div className="radio-list-modal__btns__create">
          <UniversalButton
            label={t('create_folder')}
            size="lg"
            labelColor="blue"
            labelHoverColor="blue"
            backgroundColor="white"
            backgroundHoverColor="white"
            isFullWidth
            leftIcon={<PlusСircleIcon />}
            premium={!subscreption}
            onClick={!subscreption ? handleOpenPremiumModal : openCreateFolderModal}
          />
        </div>

        <div className="radio-list-modal__btns_btn">
          <UniversalButton
            type="button"
            label={t('cancel')}
            size="lg"
            labelColor="blue"
            labelHoverColor="blue"
            backgroundColor="white"
            backgroundHoverColor="blue-light"
            onClick={handleCancel}
          />
        </div>

        <UniversalButton
          type="button"
          label={t('load')}
          size="lg"
          labelColor="white"
          labelHoverColor="white"
          backgroundColor="orange"
          backgroundHoverColor="orange-light"
          isDisabled={!activeOption}
          onClick={handleLoad}
        />
      </div>

      <div className={`option-menu-wrapper ${optionMenuFolder ? "open" : ""}`} style={{ top: optionMenuFolder?.clientY, left: optionMenuFolder?.clientX }}>
        {
          optionMenuFolder &&
          <OptionMenu closeOptionMenu={closeOptionMenuFolder}
            edit={openEditFolder}
            openProofModal={openProofModal} />
        }
      </div>
      <ModalComponent
        onCloseModal={closeCreateFolderModal}
        isVisible={isCreateFolderModal}
      >
        <CreateFolder closeCreateFolderModal={closeCreateFolderModal} addOrEditFolder={addFolder} type={"create"} />
      </ModalComponent>

      <ModalComponent
        onCloseModal={closeEditFolder}
        isVisible={isEditFolder}
      >
        <CreateFolder closeCreateFolderModal={closeEditFolder} addOrEditFolder={editFolder} type={"edit"} currentFolderName={infoAboutFolder?.folderName} />
      </ModalComponent>

      <ModalComponent
        onCloseModal={closeProofModal}
        isVisible={proofModal}
      >
        <ProofModal onCloseModal={closeProofModal} proofCallback={deleteItem} cancelButtonText={t('cancel')} proofButtonText={t('yes_delete')}>
        <div>{t('you_want_delete')} <b>“{infoAboutFolder?.folderName}”</b> {t('folder')}?</div>
        </ProofModal>
      </ModalComponent>
    </div>
  );
};

export default RadioListModal;
